import React, { useContext, useEffect } from 'react';
import parse from 'html-react-parser';
import progressContext from '../../context/loading/progresscontext';

function DynamicPage({ content }) {
    const { setProgress } = useContext(progressContext);
    const { html, css, javascript } = content || {};

    useEffect(() => {
        if (setProgress) {
            setProgress(70);
            setTimeout(() => {
                setProgress(100);
            }, 100);
        }

        if (css) {
            const styleElement = document.createElement('style');
            styleElement.innerHTML = css;
            document.head.appendChild(styleElement);
            return () => {
                if (document.head.contains(styleElement)) {
                    document.head.removeChild(styleElement);
                }
            };
        }
    }, [css, setProgress]);

    useEffect(() => {
        if (javascript) {
            try {
                // eslint-disable-next-line
                eval(javascript);
            } catch (error) {
                console.error('Error executing scripts:', error);
            }
        }
    }, [javascript]);

    return (
        <main className="dynamic-page-wrap">
            <div className="band">
                <div className="wrap">
                    {html && parse(html)}
                </div>
            </div>
        </main>
    );
}

export default DynamicPage;